import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logger } from '@/services/logger';

/**
 * Automatically tracks page-view events every time the route changes.
 * Mount this hook once at the top of your router (e.g., in App.tsx).
 */
export function usePageLogger(): void {
  const location = useLocation();
  const prevPath = useRef<string | null>(null);
  const navStart = useRef<number>(performance.now());

  useEffect(() => {
    const currentPath = location.pathname;
    if (prevPath.current !== null) {
      const durationMs = Math.round(performance.now() - navStart.current);
      logger.pageView(currentPath, { previousPage: prevPath.current });
      logger.perfMetric('page_transition', durationMs, currentPath);
    }
    prevPath.current = currentPath;
    navStart.current = performance.now();
  }, [location.pathname]);
}
